<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead :title="'Operator Departure Cities'"></cardHead>
      <dataTable
        :name="'KolayrezMatchAgencyOperators'"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="data"
        @update="matchShow = $event"
        @cellClicked="matchShow = $event.data"
        :rowClassRules="{
          // row style function
          success: (params) => {
            // var numSickDays = params.data;
            return params?.data?.OperatorId != null;
          },
        }"
      ></dataTable>
      <match
        v-if="matchShow != null"
        :setModel="matchShow"
        :operators="data"
        @match="getRow"
        @close="matchShow = null"
      ></match>
    </div>
  </div>
</template>

<script>
import match from "./match";
export default {
  name: "AgencyOperators",
  components: { match },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Id",
          width: 80,
          filter: "agNumberColumnFilter",
          field: "Id",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "ProviderId",
          width: 140,
          filter: "agNumberColumnFilter",
          field: "ProviderId",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "OperatorId",
          width: 140,
          filter: "agNumberColumnFilter",
          field: "OperatorId",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Name",
          filter: "agTextColumnFilter",
          field: "Name",
          flex: 1,
          minWidth: 140,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "AgencyName",
          filter: "agTextColumnFilter",
          field: "AgencyName",
          flex: 1,
          minWidth: 140,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "MarketName",
          filter: "agTextColumnFilter",
          field: "MarketName",
          flex: 1,
          minWidth: 140,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "",
          type: "action",
          width: 40,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-warning",
              text: '<i class="fas fa-exchange-alt"></i>',
              emit: "update",
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
        },
      ],
      data: null,
      matchShow: null,
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.$appAxiosAdmin
        .get(`kolayrez/ProviderAgencyOperators`)
        .then((response) => {
          this.data = response.data;
        });
    },
    getRow(item) {
      console.log(item);
      this.$refs.agGrid.changeRow("Id", item);
    },
  },
  computed: {},
};
</script>
